import { SearchIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Logo } from 'foundations-components/transitional/components/Logo';
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MAX_SUGGESTION_DISPLAY_LENGTH = 150;
export function AutocompleteItem({
  keyword,
  queryType,
  suggestion
}) {
  const content = React.useMemo(() => {
    let displaySuggestion = suggestion;
    if (suggestion.length > MAX_SUGGESTION_DISPLAY_LENGTH) {
      displaySuggestion = `${suggestion.substring(0, MAX_SUGGESTION_DISPLAY_LENGTH)}...`;
    }
    if (!keyword) {
      return displaySuggestion;
    }
    const parts = [];
    let remainingText = displaySuggestion;
    const keywordLower = keyword.toLowerCase();
    while (remainingText.length > 0) {
      const matchIndex = remainingText.toLowerCase().indexOf(keywordLower);
      if (matchIndex === -1) {
        parts.push( /*#__PURE__*/_jsx("span", {
          children: remainingText
        }, parts.length));
        break;
      }
      if (matchIndex > 0) {
        parts.push( /*#__PURE__*/_jsx("span", {
          children: remainingText.substring(0, matchIndex)
        }, parts.length));
      }
      parts.push( /*#__PURE__*/_jsx("strong", {
        children: remainingText.substring(matchIndex, matchIndex + keyword.length)
      }, parts.length));
      remainingText = remainingText.substring(matchIndex + keyword.length);
    }
    return parts;
  }, [keyword, suggestion]);
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    children: [/*#__PURE__*/_jsx(Flex, {
      alignItems: "center",
      blockSize: "24px",
      inlineSize: "40px",
      justifyContent: "center",
      children: /*#__PURE__*/_jsx(SearchIcon, {
        color: "fill-tertiary-pressed",
        size: "400"
      })
    }), /*#__PURE__*/_jsx(View, {
      paddingInlineStart: "500",
      children: /*#__PURE__*/_jsxs(Text, {
        textAlign: "start",
        children: [content, queryType === 'LLM' && /*#__PURE__*/_jsx(Logo, {
          height: "16px",
          marginInlineStart: "200",
          name: "breeze-symbol-gradient",
          paddingBlockStart: "100",
          width: "16px"
        })]
      })
    })]
  });
}